import { HubDataSource } from "client/Api/Hub/hub";
import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import * as pubsub from "pubsub-js";

export type CategoryFollowingChangedInfo = {
	categoryId: number;
	isFollowing: boolean;
};

export type IsNewClearedInfo = {
	kind: HubDataSource.Announcement;
	itemId: number;
	categoryIds: readonly number[];
} | {
	kind: Exclude<HubDataSource, HubDataSource.Announcement | HubDataSource.Community>;
	itemId: number;
	categoryId: number;
} | {
	kind: HubDataSource.Community;
	communityId: number;
};

export type ItemsChangedInfo = {
	changedItemKinds: ReadonlySet<HubItemKind>;
};

export enum HubEvent {
	CategoryFollowingChanged = "hub.category.followingChanged",
	IsNewStatusCleared = "hub.isNew.statusCleared",
	ItemsChanged = "hub.items.changed",
	HierarchyChanged = "hub.hierarchy.changed",
}

type Data<T extends HubEvent> =
	T extends HubEvent.CategoryFollowingChanged ? CategoryFollowingChangedInfo:
	T extends HubEvent.IsNewStatusCleared ? IsNewClearedInfo :
	T extends HubEvent.ItemsChanged ? ItemsChangedInfo :
	T extends HubEvent.HierarchyChanged ? undefined :
	never;

export const subscribe: <T extends HubEvent>(kind: T, callback: (message: string, data: Data<T>) => void) => PubSubSubscriptionToken = pubsub.subscribe;
export const publish: <T extends HubEvent>(kind: T, data: Data<T>) => void = pubsub.publish;
export const unsubscribe: (token: PubSubSubscriptionToken) => void = pubsub.unsubscribe;
